<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h3>Work in progress...</h3>
		</div>
	</div>
  <img src="assets/irinox/images/website-under-construction.jpg" alt="Work in progress..."/>
</template>

<script>
export default {
}
</script>

<style scoped>
img {
  position: fixed;
  bottom: -50px;
  right: 0;
  max-width: 100%;
}
</style>